import React from 'react';
import "../../../css/duty-information.css"
import {Template} from "../../../components/template/template.jsx";
// import "../../../css/style-dash.css"
import "../../../css/style-dashboards.css";
import DutyGarrisonCard from "./components/duty-garrison-card.jsx";
import useSse from "./hooks/use-sse.js";
import DutyAttendanceCard from "./components/duty-attendance-card.jsx";
import DutyDispatchCard from "./components/duty-dispatch-card.jsx";

const DutyInformation = () => {
    const {graphData, countersData, tableData} = useSse();

    return (
        <Template className={"dash"} isLoading={!graphData || !countersData || !tableData}>
            <Template.Header className={"bg-transparent! border-b-0!"}>
                <Template.Title className={"text-[#F4FFFF]!"}>
                    Informações do plantão - Acompanhamento em tempo real
                </Template.Title>
            </Template.Header>
            <Template.Body className="dash-body dashboard-wall-body h-[calc(100vh-69px)] grid grid-cols-4 grid-rows-2 relative gap-x-(--dash-gap-md) gap-y-(--dash-gap-md)">
                {
                    graphData && countersData && tableData &&
                    <>
                        <DutyGarrisonCard countersData={countersData} graphData={graphData} tableData={tableData}/>

                        <DutyAttendanceCard graphData={graphData}/>

                        <DutyDispatchCard countersData={countersData} graphData={graphData}/>
                    </>

                }
            </Template.Body>
        </Template>
    );
};

export default DutyInformation;
